import { render, staticRenderFns } from "./InformationAboutHeathPage.vue?vue&type=template&id=c69668f0&"
import script from "./InformationAboutHeathPage.vue?vue&type=script&lang=js&"
export * from "./InformationAboutHeathPage.vue?vue&type=script&lang=js&"
import style0 from "./InformationAboutHeathPage.vue?vue&type=style&index=0&id=c69668f0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports